export const PICKING_STATES_TRANSLATION: Array<{ label: string; value: string }> = [
  { label: 'Vacío', value: 'EMPTY' },
  { label: 'Parcial', value: 'PARTIAL' },
  { label: 'Completo', value: 'COMPLETED' },
  { label: 'Desmontar', value: 'UNMOUNT' }
]
